import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Modal de confirmación reutilizable.
 *
 * Props:
 *  - open: boolean
 *  - titulo: string (opcional)
 *  - mensaje: string
 *  - labelConfirmar: string (default "Eliminar")
 *  - destructivo: boolean (default true — botón rojo)
 *  - onConfirmar: function
 *  - onCancelar: function
 *
 * Se renderiza vía portal a document.body para que siempre quede por
 * encima de cualquier drawer/modal ancestro, sin importar cuántos
 * niveles de anidamiento haya (expediente → cliente → trámite, etc.).
 */
export default function ConfirmModal({
  open,
  titulo = 'Confirmar',
  mensaje,
  labelConfirmar = 'Eliminar',
  destructivo = true,
  onConfirmar,
  onCancelar,
}) {
  if (!open) return null;

  return createPortal(
    <div
      className="modal-overlay"
      onMouseDown={e => e.target === e.currentTarget && onCancelar()}
      style={{ zIndex: 1100 }}
    >
      <div className="modal" style={{ width: 400, maxWidth: '90vw' }}>
        <div className="modal-header">
          <div className="modal-title">{titulo}</div>
          <button className="modal-close" onClick={onCancelar}>✕</button>
        </div>
        <div className="modal-body">
          <p style={{ margin: 0, color: 'var(--text)', lineHeight: 1.5 }}>{mensaje}</p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onCancelar}>Cancelar</button>
          <button
            className="btn"
            onClick={onConfirmar}
            style={destructivo ? { background: '#ef4444', color: '#fff', border: 'none' } : {}}
          >
            {labelConfirmar}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
